import { CommonModel } from '@telialt/models/src/CommonModel';
import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

import { apiGetSearchQuery } from '../../api';
import { SEARCH_SERVICES_SUGGESTIONS_COUNT, SEARCH_SPECIAL_OFFERS_SUGGESTIONS_COUNT } from '../../constants';
import { SearchQueryKeysMap, SearchQueryParams, ServiceSearchItem } from '../../model';
import { getQueryKeyPrefixBySegment } from '../../utils/segment';

type Params = {
    searchText: string;
    segment: CommonModel.Segment;
    queryKeys: SearchQueryKeysMap;
    signal?: AbortSignal;
};

export const loadServicesSuggestions = async ({ searchText, segment, queryKeys, signal }: Params) => {
    const queryKeyPrefix = getQueryKeyPrefixBySegment(segment);

    const searchParams: SearchQueryParams = {
        searchText,
        offset: 0,
        limit: searchText ? SEARCH_SERVICES_SUGGESTIONS_COUNT : SEARCH_SPECIAL_OFFERS_SUGGESTIONS_COUNT,
    };

    try {
        const response = await apiGetSearchQuery<ServiceSearchItem>(
            queryKeys[`${queryKeyPrefix}-services`],
            searchParams,
            signal,
        );

        return { services: response.data };
    } catch (error) {
        datadogLogger().warn(error, { component: DDComponent.Search });

        return { error };
    }
};
